import { render, staticRenderFns } from "./WatSponsorsList.vue?vue&type=template&id=1800b9a4&"
import script from "./WatSponsorsList.vue?vue&type=script&lang=js&"
export * from "./WatSponsorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports